import Validator from "jsonschema";

export const createValidator = (schemas) => {
  const v = new Validator.Validator();

  // Register schemas
  schemas.forEach((schema) => {
    if (schema.properties) {
      Object.values(schema.properties).forEach((prop) => {
        if (prop.$id) {
          v.addSchema(prop, prop.$id);
        }
      });
    }
    v.addSchema(schema, schema.$id);
  });

  return {
    getSchema: (schemaId) => {
      const validateFn = (data) => {
        try {
          const schema = schemas.find((s) => s.$id === schemaId);
          if (!schema) {
            return true;
          }

          const result = v.validate(data, schema);

          if (result.errors && result.errors.length > 0) {
            validateFn.errors = result.errors.map((err) => {
              // Handle 'required' errors specially
              if (err.name === "required") {
                return {
                  message: `${err.argument} is required`,
                  keyword: "required",
                  params: { missingProperty: err.argument },
                  schemaPath: `${schemaId}/required`,
                  instancePath: "",
                };
              }
              // For other errors, maintain structure similar to Ajv
              return {
                message: err.message,
                keyword: err.name,
                params: err.argument || {},
                schemaPath: `${schemaId}${err.path}`,
                instancePath: err.property.replace(/^instance\./, ""),
              };
            });
            return false;
          }

          validateFn.errors = null;
          return true;
        } catch (e) {
          console.error(`Validation error for schema ${schemaId}:`, e);
          validateFn.errors = null;
          return true;
        }
      };

      validateFn.errors = null;
      return validateFn;
    },
  };
};
